import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('https://carriera-backend.onrender.com/api/auth/login', {
        email,
        password
      });

      // Save token and user info
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      navigate('/dashboard');

    } catch (err) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-carriera-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">

        {/* Logo & Title */}
        <div className="mb-10">
          <h1 className="font-serif text-3xl font-normal text-carriera-text mb-2">
            Carriera
          </h1>
          <p className="text-carriera-muted text-sm">
            Recruitment & Corporate Training Dashboard
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white border border-carriera-border p-8"
             style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>

          <h2 className="font-serif text-xl font-normal text-carriera-text mb-6">
            Sign in to your account
          </h2>

          <form onSubmit={handleLogin}>

            {/* Email */}
            <div className="mb-5">
              <label className="block text-xs font-medium text-carriera-sec uppercase tracking-widest mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@carriera.com.my"
                required
                className="w-full border border-carriera-border px-3 py-2.5 text-sm text-carriera-text bg-carriera-bg outline-none focus:border-carriera-accent transition-colors duration-200"
              />
            </div>

            {/* Password */}
            <div className="mb-6">
              <label className="block text-xs font-medium text-carriera-sec uppercase tracking-widest mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full border border-carriera-border px-3 py-2.5 text-sm text-carriera-text bg-carriera-bg outline-none focus:border-carriera-accent transition-colors duration-200"
              />
            </div>

            {/* Error message */}
            {error && (
              <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2">
                {error}
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-carriera-text text-white py-2.5 text-sm font-medium hover:bg-carriera-accent transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>

          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-carriera-muted mt-6">
          Carriera Internal Dashboard · Authorised Access Only
        </p>

      </div>
    </div>
  );
}
